import { securityAuthenticationForgotPasswordAsyncSlice } from './post';

export const {
	requestPostSecurityAuthenticationForgotPassword,
	resetPostSecurityAuthenticationForgotPassword
} = securityAuthenticationForgotPasswordAsyncSlice.asyncActionCreators;
